import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/API/Study";
import { useMutation, useQueryClient } from "react-query";
import useGoNext from "./Hooks/useGoNext";
import useCurrentSection from "./Hooks/useCurrentSection";
import Toast from '../Tools/Toast';
import useSectionChange from "./Hooks/useSectionChange";
import useIsLastSection from "./Hooks/useIsLastSection";
import { txt } from "../../services/translation";

export default function NextButton({show, data}){

    const [toast, setToast] = useState(false)

    const goNext = useGoNext();
    const section = useCurrentSection();
    const isEnd = useIsLastSection()

    const {course} = useParams();

    const [loading, setLoading] = useState(false)

    const changeSection = useSectionChange();

    const queryClient = useQueryClient();

    /** Mark current section as completed */
    const completeSection = useMutation({

        mutationFn: s => API.completeSection(course, s),

        onMutate: async () => {
            setLoading(true);
            return await changeSection({...section, completed: true})
        },

        onSuccess(){
            setLoading(false)
            return goNext();
        },

        onError: (e, data, context) => {
            setLoading(false);
            setToast(['error', txt('errorSavingProgress')])
            queryClient.setQueryData(course, context.previous)
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: course })
        },
    })


    const onClick = () => {

        if(section?.completed) return goNext();

        const s = {...section};
        Object.assign(s, data || {});
        

        return completeSection.mutate(s)
    }

    const finished = section.completed && isEnd

    const text = section?.completed ? txt('continue') : 
        (isEnd ? txt('finish') : txt('finishAndContinue'));

    return show !== false && <>

        {finished ? <></> : 
            <LoadingButton 
                id='next-button'
                variant='contained' 
                onClick={onClick}
                loading={loading}
            >
                {text}
            </LoadingButton>
        }

        <Toast 
            open={toast} 
            severity={toast[0]} 
            message={toast[1]} 
            onClose={() => setToast(false)} 
        />

    </>
}